"use client"

import { WifiCog } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `WifiCogIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const WifiCogIcon = component(Icon)({ as: WifiCog })
